import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../actions/counterSlice'
import userReducer from '../actions/userAction'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    user:userReducer
  },
})